import { useQuery } from '@tanstack/react-query';

import { ISecondRoot } from 'modules/global';

import { getDirectionByName } from '../queries';
import { privateUniversityConst } from '..';

export const useUniversityByName = (directionName?: string | string[]) => {
  const { data: universityByName, ...args } = useQuery<ISecondRoot[]>({
    queryKey: [privateUniversityConst.queryKeys.DIRECTION_BY_NAME, directionName],
    queryFn: getDirectionByName(directionName),
    enabled: !!directionName
  });

  return { universityByName, ...args };
};
